import { render, staticRenderFns } from "./WPagination.vue?vue&type=template&id=3d8e665f&"
import script from "./WPagination.vue?vue&type=script&lang=ts&"
export * from "./WPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports